module.exports = __webpack_public_path__ + "d6375bc75a3753baf861333bc4c573a0.pdf";